import { styled } from '~/styled'

export const DrawerMain = styled('div', {
  base: ['p-4', 'w-full', 'grow', 'overflow-y-auto']
})
